export default "__VITE_ASSET__BfTGAbjb__"